import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import FilterListIcon from '@material-ui/icons/FilterList';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import Badge from '@material-ui/core/Badge';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
  currentViewNameState,
  userPreferencesState,
} from '../HomePage/TicketList/TicketListSlice';
import {
  rowsFiltersForTicketHistoricState,
  sortConfigState,
} from '../WagonDetailsPage/WagonDetailsPageSlice';
import {
  setSelectedMenuTab,
  selectedMenuTabState,
} from '../HomePage/ContentTabs/ContentTabsSlice';
import {
  rowsFiltersForWorkshopTimeState,
  sortConfigForWorkshopTimeState,
} from '../WorkshopTimePage/WorkshopTimeSlice';
import { userInfoState } from '../HomePage/HomeSlice';
import FilterPopper from './FilterPopper';
import useStyles from './styles';

export default function TicketsTableHead(props) {
  const { headCells, rows } = props;
  const [filteredCells, setFilteredCells] = React.useState(headCells);
  const [selectedCell, setSelectedCell] = React.useState('ticketNumber');
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [placement, setPlacement] = React.useState(null);
  const selectedTicketTable = useSelector(selectedMenuTabState);
  const currentViewName = useSelector(currentViewNameState);
  const userPreferences = useSelector(userPreferencesState);
  const location = useLocation();
  const dispatch = useDispatch();
  const rowsFiltersForTicketHistoric = useSelector(
    rowsFiltersForTicketHistoricState,
  );
  const rowsFiltersForWorkshopTime = useSelector(
    rowsFiltersForWorkshopTimeState,
  );
  const [filterCell, setFilterCell] = React.useState([]);
  const { rowsFilters, filteredColumns, sortConfig } = userPreferences.find(
    (userPreference) => userPreference.viewName === currentViewName,
  );
  const sortConfigTicketHistoric = useSelector(sortConfigState);
  const sortConfigWorkshopTime = useSelector(sortConfigForWorkshopTimeState);
  const [defaultSortConfig, setDefaultSortConfig] = React.useState([]);
  const user = useSelector(userInfoState);

  const classes = useStyles();
  const { t } = useTranslation();

  const handleClick = (event, cell) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
    setSelectedCell(cell);
  };
  useEffect(() => {
    if (selectedCell && filteredCells.length > 1) {
      if (
        selectedCell === filteredCells[filteredCells.length - 1].id ||
        selectedCell === filteredCells[filteredCells.length - 2].id
      ) {
        setPlacement('bottom-end');
      } else {
        setPlacement('bottom-start');
      }
    } else {
      setPlacement('bottom-start');
    }
  }, [selectedCell, filteredCells]);

  useEffect(() => {
    if (
      selectedTicketTable !== 'ticketHistoric' &&
      selectedTicketTable !== 'workshopTime' &&
      filteredColumns
    ) {
      setFilteredCells(
        headCells.filter(
          (item) =>
            filteredColumns[item.id] === true &&
            (user.internal ||
              user.hasEmilyDRights ||
              user.externalMax ||
              item.mandatory === true),
        ),
      );
    } else {
      setFilteredCells(headCells);
    }
  }, [user, filteredColumns, selectedTicketTable]);

  useEffect(() => {
    if (location.pathname === '/') {
      dispatch(setSelectedMenuTab('ticketList'));
    } else if (location.pathname.indexOf('wagon/details') !== -1) {
      dispatch(setSelectedMenuTab('ticketHistoric'));
    } else if (location.pathname.indexOf('analytics/workshop-time') !== -1) {
      dispatch(setSelectedMenuTab('workshopTime'));
    }
  }, []);

  useEffect(() => {
    setFilterCell(
      selectedTicketTable === 'ticketHistoric'
        ? rowsFiltersForTicketHistoric
        : selectedTicketTable === 'ticketList'
        ? rowsFilters
        : rowsFiltersForWorkshopTime,
    );
  }, [
    rowsFiltersForTicketHistoric,
    rowsFiltersForWorkshopTime,
    selectedTicketTable,
    rowsFilters,
  ]);

  useEffect(() => {
    setDefaultSortConfig(
      selectedTicketTable === 'ticketHistoric'
        ? sortConfigTicketHistoric
        : selectedTicketTable === 'ticketList'
        ? sortConfig
        : sortConfigWorkshopTime,
    );
  }, [
    selectedTicketTable,
    sortConfig,
    sortConfigTicketHistoric,
    sortConfigWorkshopTime,
    currentViewName,
  ]);

  function getAnchorEl() {
    setAnchorEl(null);
  }

  function isFiltered(filterCellSelected, headCell) {
    return (
      filterCellSelected.filter((item) => item.cell === headCell.id).length >
        0 &&
      filterCellSelected.filter((item) => item.cell === headCell.id)[0]
        .selectedOptions.length > 0
    );
  }

  function isSorting(sortConfigSelected, headCell) {
    return (
      sortConfigSelected.filter((item) => item.propertyName === headCell.id)
        .length > 0
    );
  }

  function isSortingAsc(sortConfigSelected, headCell) {
    return (
      sortConfigSelected.filter((item) => item.propertyName === headCell.id)[0]
        .sortType === 'asc'
    );
  }

  function orderNumber(sortConfigSelected, headCell) {
    return (
      sortConfigSelected.findIndex(
        (item) => item.propertyName === headCell.id,
      ) + 1
    );
  }

  return (
    <TableHead>
      <TableRow>
        {filteredCells.map((headCell) => (
          <TableCell
            onClick={(e) => handleClick(e, headCell.id)}
            key={headCell.id}
            className={classes.tableHead}
            align="left"
          >
            {t(headCell.label)}
            {isFiltered(filterCell, headCell) ? (
              <FilterListIcon className={classes.filterListIcon} />
            ) : isSorting(defaultSortConfig, headCell) ? (
              isSortingAsc(defaultSortConfig, headCell) ? (
                <Badge badgeContent={orderNumber(defaultSortConfig, headCell)}>
                  <ArrowUpwardIcon className={classes.arrow} />
                </Badge>
              ) : (
                <Badge badgeContent={orderNumber(defaultSortConfig, headCell)}>
                  <ArrowDownwardIcon className={classes.arrow} />
                </Badge>
              )
            ) : (
              <ExpandMoreIcon className={classes.expandMoreIcon} />
            )}
          </TableCell>
        ))}
      </TableRow>
      <FilterPopper
        initialAnchorEl={anchorEl}
        placement={placement}
        rows={rows}
        selectedCell={selectedCell}
        sendAnchorEl={getAnchorEl}
      />
    </TableHead>
  );
}
